import { SubscriptionPlan } from "@/types/types";

export const canUseLibrary = (subscriptionPlan: SubscriptionPlan) => {
  // Free plan
  return (
    subscriptionPlan === "first" ||
    subscriptionPlan === "second" ||
    subscriptionPlan === "third"
  );
};
